import React from 'react'

import { Dialog } from 'primereact/dialog'
import DialogFooter from '../dialogFooter'

import GeneralServices from '../../app/service/generalServices'
import ProductCrudTable from '../../views/product/productCrudTable'
import { Button } from 'primereact/button'
import ProductDialog from './productDialog'

class ChooseProductDialog extends React.Component {

    state = {

        selectedProduct: '',
        productList: [],
        filteredProductList: [],

        searchText: '',

        didUpdated: false,

    }

    componentDidUpdate(){
        this.setStates()
    }

    setStates = () => {
        if( (this.props.visible && !this.state.didUpdated) || this.props.forceUpdate ){
            this.setState({searchText: ''})
            this.setState({productList: this.props.list})
            this.setState({filteredProductList: this.props.list})

                
            this.setState({didUpdated: true})

            if(this.props.doneForceUpadte){
                this.props.doneForceUpadte()
            }

        }
    }

    handleChange = async (event) => {
        const value = event.target.value
        const name = event.target.name
        await this.setState({ [name]: value })
        this.filter()
    }

    handleKeyPress = async (e) => {
        if (e.key === "Enter") {
            const filteredList = JSON.parse(JSON.stringify(this.state.filteredProductList))
            if(filteredList.length === 1){
                await this.setState({selectedProduct: filteredList[0]})
                this.callSave()
            }
          }
    }

    handleSelectionChange = (value) => {
        if(value === null){ //significa que clicou em cima do item que estava selecionado antes (double click)
            this.callSave()
        } else{
            this.setState({selectedProduct: value})
        }
    }

    hideDialog = () => {
        this.setState({didUpdated: false})
        this.props.hideDialog()
    }

    callSave = async () => {
        await this.props.handleSelectionChange(this.state.selectedProduct)
        this.hideDialog()
    }

    filter  = () => {
        
        this.setState({
            filteredProductList:
                JSON.parse(
                    JSON.stringify(
                        this.state.productList.filter(product => {
                            return(
                                GeneralServices.includeString(product.codigo, this.state.searchText)
                                || GeneralServices.includeString(product.descricao, this.state.searchText)
                            )
                        }
                        )
                    )
                )
        })
    }

    render () {

        const chooseProductDialogFooter = (
            <DialogFooter save = {this.callSave} hideDialog = {this.hideDialog} disabled={this.props.disabled}/>
        )

        const renderCadastrarProdutoCompraButton = () => {
            if(this.props.isBuyProducts){
                return (
                    <>
                    <br />
                    <div className="row">
                    <div className="col-md-4">
                        <Button
                            label="Cadastrar Produto de Compra"
                            icon="pi pi-save"
                            className=" small-font"
                            style={{maxHeight: '25px', marginLeft: '10px'}}
                            onClick={() => this.setState({displayProductDialog: true})}
                        />
                    </div>
                    </div>
                    </>
                )
            }
        }

        const renderProductDialog = () => {
            if(this.state.displayProductDialog){
                return (
                    <ProductDialog
                        visible={this.state.displayProductDialog}
                        header="Cadastrar Produto de Compra"
                        hideDialog={() => this.setState({displayProductDialog: false})}
                        isProdutoCompra
                        search={this.props.searchProdutosCompra}
                        fornecedor={this.props.fornecedor}
                    />
                )
            }
        }

        return (
            <>
            <Dialog 
                    visible={this.props.visible}
                    style={{ width: '70vw' }}
                    header={this.props.header}
                    modal
                    className="p-fluid"
                    footer={chooseProductDialogFooter}
                    onHide={this.hideDialog}
            >

                <div className="p-field">
                    <label htmlFor="search conta">Busca</label>
                    <input style={{color: '#000'}}
                        autoFocus  
                        className={"form-control " }
                        type="text"
                        id="searchText"
                        name="searchText"
                        value={this.state.searchText}
                        placeholder="Pesquise por código ou descrição"
                        onChange = {this.handleChange}
                        onKeyPress={this.handleKeyPress}
                    />
                </div>

                {renderCadastrarProdutoCompraButton()}

                <br />

                <ProductCrudTable 
                    list = { this.state.filteredProductList }
                    simpleView
                    searchText={this.state.searchText}
                    isBuyProducts={this.props.isBuyProducts}
                    handleSelectionChange={this.handleSelectionChange}
                    selectable={true}
                    loading = {this.state.loadingContaBancariaTable}
                /> 


            </Dialog>

            {renderProductDialog()}

            </>
        )
    }


}

export default ChooseProductDialog